module.exports = __webpack_public_path__ + "files/9cc8b8ab9d6ebab7b41c73d2e864409c.png";